// @vendors
const Immutable = require('immutable');

// @utilities
const { getDay, todayDate } = require('utilities/dateHelper');

// @constants
const {
    EURO_SYMBOL,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
} = require('constants/index');
const {
    SIGNATURE_PATTERN_SMS_VALIDATION_FAILURE,
} = require('constants/actionTypes');
const {
    CONTRIBUTION_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_PUNCTUAL,
} = require('../raConstants/index');
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    valid: true,
    submitSuccessful: false,
    hireData: {
        // @TODO: Replace this model to swagger's providedModel
        contribution: {
            amount: 0, // @hardcoded
            currency: EURO_SYMBOL, // @hardcoded
            isDirty: false,
        },
        selectedAccount: {
            balance: null,
            id: null,
            errorFlag: false,
        },
    },
    isLoading: false,
    steps: [
        {
            valid: false,
        },
        {
            valid: false,
        },
        {
            valid: false,
        },
    ],
    visibleStep: null,
    periodicity: CONTRIBUTION_PERIOD_MONTHLY,
    contributionDay: getDay(todayDate()),
    recurringContributionAmount: 0,
    portfolio: null,
    recurringValidationData: {},
    generatedPdf: null,
    fetchingPdf: false,
    errorOnPdf: false,
});

function validateForm(state) {
    return state; // @hardcoded
}

function validateUIStep(state, step) {
    let stepIsValid = false;
    let errorFlag = false;
    switch (step) {
        case FIRST_STEP:
            if (
                state.getIn(['hireData', 'contribution', 'amount']) >= 1 &&
                state.get('portfolio')
            ) {
                stepIsValid = true;
            }
            break;
        case SECOND_STEP:
            if (state.getIn(['hireData', 'selectedAccount', 'id'])) {
                const isPeriodic =
                    state.get('periodicity') !== CONTRIBUTION_PERIOD_PUNCTUAL;
                const invalidAmount =
                    state.getIn([
                        'hireData',
                        'selectedAccount',
                        'balance',
                        'amount',
                    ]) < state.getIn(['hireData', 'contribution', 'amount']);
                stepIsValid = isPeriodic || !invalidAmount;
                errorFlag = !stepIsValid;
            }
            break;
        case THIRD_STEP:
            stepIsValid = true;
            break;
        default:
            return state;
    }
    return state
        .setIn(['steps', step, 'valid'], stepIsValid)
        .setIn(['hireData', 'selectedAccount', 'errorFlag'], errorFlag);
}

const RAAdditionalContribution = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_IN_PROGRESS:
            return state.merge({
                isLoading: true,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_SUCCESS:
            return state.merge({
                submitSuccessful: true,
                isLoading: false,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_FAILURE:
            return state.merge({
                isLoading: false,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_VALIDATION_MONEY_FAILURE:
            return state.merge({
                isLoading: false,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_VALIDATE_FORM:
            return validateForm(state);
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_CONTRIBUTION_AMOUNT:
            return state.mergeIn(['hireData', 'contribution'], {
                amount: action.payload,
                isDirty: true,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_ACCOUNT:
            return state.mergeIn(['hireData', 'selectedAccount'], {
                id: action.payload.accountId,
                balance: action.payload.accountBalance,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_RESET:
            return initialState;
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_CONTRIBUTION_DAY:
            return state.merge({
                contributionDay: action.payload.day,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_RECURRING_CONTRIBUTION_AMOUNT:
            return state.mergeIn(
                ['hireData', 'contribution', 'amount'],
                action.payload.amount,
            );
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_RESET_STEP:
            return state.mergeIn(
                ['steps', action.payload.step],
                initialState.getIn(['steps', action.payload.step]),
            );
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_VISIBLE_STEP:
            return state.merge({
                visibleStep: action.payload.step,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_VALIDATE_UI_STEP:
            return validateUIStep(state, action.payload.step);
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_PERIODICITY:
            return state.merge({
                periodicity: action.payload.periodicity,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_SET_PORTFOLIO:
            return state.merge({
                portfolio: action.payload.portfolio,
                periodicity: action.payload.periodicity,
                visibleStep: FIRST_STEP,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_RECURRING_TRANSFER_VALIDATION_SUCCESS:
            return state.merge({
                recurringValidationData: action.payload.response,
            });
        case SIGNATURE_PATTERN_SMS_VALIDATION_FAILURE:
            return state.merge({
                isLoading: false,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_RESET_PORTFOLIO:
            return state.merge({ portfolio: null });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_GET_PDF_FETCHING:
            return state.merge({
                fetchingPdf: true,
                errorOnPdf: false,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_GET_PDF_SUCCESS:
            return state.merge({
                generatedPdf: action.payload.generatedPdf,
                fetchingPdf: false,
                errorOnPdf: false,
            });
        case actionTypes.RA_ADDITIONAL_CONTRIBUTION_GET_PDF_FAILURE:
            return state.merge({
                generatedPdf: null,
                fetchingPdf: false,
                errorOnPdf: true,
            });
        default:
            return state;
    }
};

module.exports = RAAdditionalContribution;
